import dayjs from "dayjs";
import { TFunction } from "i18next";
import { formatNumber } from "../../../../../../common/utils";
import { ThirdPartySiteDetailsDTO } from "../../../../../../datasources/api-client/data-contracts";
import { DisplayItem, item, itemMV, safeLabel } from "../../../../utils";

export const displayValuesThirdPartySite = (data: ThirdPartySiteDetailsDTO | undefined, t: TFunction, lang: string) => {
	if (!data) {
		return {
			emissions: [] as DisplayItem[],
			siteData: [] as DisplayItem[],
		};
	}

	const siteData: DisplayItem[] = [
		item(t("source emission"), data.sourceLabel),
		item(
			t("period"),
			data.from && data.to
				? `${dayjs(data.from).format("DD/MM/YYYY")} - ${dayjs(data.to).format("DD/MM/YYYY")}`
				: "-"
		),
		item(t("methodology"), data.methodologyLabel),
		item(t("isCertified"), data.isCertified ? t("yes") : t("no")),
		item(t("scope"), data.scope, true),
		item(t("scope category"), safeLabel(data.scopeCategoryLabel, data.scopeCategoryId), true),

		itemMV(`${t("emission scope")} 1`, data.emissionsScope1),
		itemMV(`${t("emission scope")} 2`, data.emissionsScope2),
		itemMV(`${t("emission scope")} 3`, data.emissionsScope3),
		itemMV(`${t("emission")} Ttw`, data.emissionsTtw),
		itemMV(`${t("emission")} Wtw`, data.emissionsWtw),
		itemMV(t("energy consumed"), data.energy),
		itemMV(t("marketbase emissions"), data.marketBasedEmissions),
		itemMV("CO2", data.co2),
		itemMV("CH4", data.ch4),
		itemMV("N2O", data.n2o),
		itemMV("PMx", data.pmx),
		item(t("source year"), data.sourceYear, true),
		item(t("node code"), data.nodeCode, true),
		item("GWP", data.gwp, true),
		item(t("measurement"), safeLabel(data.measureLabel, data.measureId), true),
		item(t("consumption type"), safeLabel(data.consumptionTypeLabel, data.consumptionTypeId), true),
		item(t("coutry code"), data.nodeCountry, true),
		item(t("city code"), data.nodeCity, true),
		item(t("refrigerant"), safeLabel(data.refrigerantLabel, data.refrigerantId), true),
		item(t("temperature"), safeLabel(data.temperatureLabel, data.temperatureId), true),
		item(t("area"), data.area, true, (v) => formatNumber(v, "decimal", 2)),
		item(t("goods flow"), data.goodsFlow, true, (v) => formatNumber(v, "decimal", 2)),
		item(t("id import"), data.importCode, true),
		item(t("insert date"), data.insertDate ? dayjs(data.insertDate).format("DD/MM/YYYY") : "-"),
		item(t("description"), data.description, true),
	];

	const emissions: DisplayItem[] = [
		itemMV(t("total emissions"), data.emissions, false),
		itemMV(t("intensity emissions"), data.emissionsIntensity, false),
		itemMV(t("biogenic emissions"), data.emissionsBio, false),
	];

	return { emissions, siteData };
};
